/* BlackHype (2026-10-08): guia de tamanhos em popup (dialog). Abre por [data-bh-sg-open], troca de aba,
   converte cm/kg <-> in/lb e destaca a linha do tamanho selecionado na página. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-bh-sg]'); if (!dlg || dlg.dataset.pronto) return; dlg.dataset.pronto = '1';
  if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
  var norm = function (s) { return String(s || '').toUpperCase().replace(/\s+/g, '').replace(/^XXXXL$/, '4XL').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL'); };

  function tamanhoAtual() {
    var radios = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) if (/size|tamanho|taille|talla|gr[oö][sß]e/i.test(radios[i].name || '')) return radios[i].value;
    return radios.length ? radios[0].value : '';
  }
  function destacar() {
    var alvo = norm(tamanhoAtual());
    dlg.querySelectorAll('[data-bh-sg-size]').forEach(function (tr) { tr.classList.toggle('is-current', !!alvo && norm(tr.getAttribute('data-bh-sg-size')) === alvo); });
  }
  function aba(qual) {
    dlg.querySelectorAll('[data-bh-sg-tab]').forEach(function (b) { var on = b.getAttribute('data-bh-sg-tab') === qual; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    dlg.querySelectorAll('[data-bh-sg-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bh-sg-panel') === qual); });
  }
  function unidade(qual) {
    var imp = qual === 'imperial';
    dlg.querySelectorAll('[data-bh-sg-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bh-sg-unit') === qual ? 'true' : 'false'); });
    dlg.querySelectorAll('[data-bh-sg-u]').forEach(function (s) { var base = s.getAttribute('data-bh-sg-u'); s.textContent = imp ? (base === 'kg' ? 'lb' : 'in') : base; });
    dlg.querySelectorAll('[data-bh-sg-v]').forEach(function (td) {
      var bruto = td.getAttribute('data-bh-sg-v'), base = td.getAttribute('data-bh-sg-base');
      td.textContent = !imp ? bruto : bruto.replace(/\d+(\.\d+)?/g, function (n) { return base === 'kg' ? String(Math.round(parseFloat(n) * 2.2046)) : String(Math.round(parseFloat(n) / 2.54 * 10) / 10); });
    });
  }
  function abrir(e) {
    if (e) e.preventDefault();
    aba(dlg.getAttribute('data-cat') || 'men'); destacar();
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    document.documentElement.classList.add('bh-sg-open');
  }
  function fechar() { if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('bh-sg-open'); }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-bh-sg-open]')) return abrir(e);
    if (t.closest('[data-bh-sg-close]')) return fechar();
    var b = t.closest('[data-bh-sg-tab]'); if (b) return aba(b.getAttribute('data-bh-sg-tab'));
    var u = t.closest('[data-bh-sg-unit]'); if (u) return unidade(u.getAttribute('data-bh-sg-unit'));
    if (t === dlg) fechar(); // clique no fundo escuro
  });
  dlg.addEventListener('close', function () { document.documentElement.classList.remove('bh-sg-open'); });
})();
